/**
 * Детерминированный генератор случайных чисел (mulberry32).
 * Состояние — одно беззнаковое 32-битное число, поэтому оно сериализуемо и воспроизводимо.
 */
const UINT32_RANGE = 4294967296;
export function nextUint32(state) {
    const next = (state + 0x6d2b79f5) >>> 0;
    let t = next;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return { value: (t ^ (t >>> 14)) >>> 0, state: next };
}
/** Целое число в диапазоне [0, maxExclusive). */
export function nextInt(state, maxExclusive) {
    if (!Number.isInteger(maxExclusive) || maxExclusive <= 0) {
        throw new RangeError(`maxExclusive must be a positive integer, got ${maxExclusive}`);
    }
    const step = nextUint32(state);
    return { value: Math.floor((step.value / UINT32_RANGE) * maxExclusive), state: step.state };
}
/** Финальное перемешивание MurmurHash3: равномерно распределяет биты seed. */
function fmix32(input) {
    let h = input >>> 0;
    h ^= h >>> 16;
    h = Math.imul(h, 0x85ebca6b);
    h ^= h >>> 13;
    h = Math.imul(h, 0xc2b2ae35);
    h ^= h >>> 16;
    return h >>> 0;
}
/** Приводит seed к 32-битному целому. Строка хешируется FNV-1a. */
export function normalizeSeed(seed) {
    if (typeof seed === 'number') {
        if (!Number.isFinite(seed)) {
            throw new RangeError(`seed must be finite, got ${seed}`);
        }
        return Math.trunc(seed) >>> 0;
    }
    let hash = 0x811c9dc5;
    for (let i = 0; i < seed.length; i++) {
        hash ^= seed.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
}
/** Независимый поток случайных чисел из общего seed (например, отдельно для вирусов и капсул). */
export function deriveSeed(seed, salt) {
    return fmix32((seed ^ salt) >>> 0);
}
//# sourceMappingURL=rng.js.map